import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";

interface TableState {
  currentPage: number;
  rowsPerPage: number;
  searchTerm: string;
  dateRange: [string | null, string | null];
  selectedRows: string[];

  sortField: string;
  sortOrder: "asc" | "desc" | null;
}


const initialState: TableState = {
  currentPage: 1,
  rowsPerPage: 25,
  searchTerm: "",
  dateRange: [
    dayjs().subtract(7, "day").format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ],
  selectedRows: [],
  sortField: "",
  sortOrder: null
};


const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setDateRange: (
      state,
      action: PayloadAction<[string | null, string | null]>
    ) => {
      state.dateRange = action.payload;
    },
    setSelectedRows: (state, action: PayloadAction<string[]>) => {
      state.selectedRows = action.payload;
    },
    setSort: (state, action: PayloadAction<{field: string}>) => {
      if (state.sortField === action.payload.field) {
        state.sortOrder = state.sortOrder === "asc" ?"desc":"asc"
      } else {
        state.sortField = action.payload.field;
        state.sortOrder = "asc";
      }
      state.currentPage = 1;
    },
    resetTableState: () => initialState,
  },
});

export const {
  setPage,
  setRowsPerPage,
  setSearchTerm,
  setDateRange,
  setSelectedRows,
  setSort,
  resetTableState,
} = tableSlice.actions;

export default tableSlice.reducer;